module.exports = __webpack_public_path__ + "static/media/Milex-Pessaries-Brochure@2x.4af02f24.png";